import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/useAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, verifyAuth } = useAuth();
  
  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      if (!isAuthenticated && !isLoading && mounted) {
        await verifyAuth();
      }
    };

    checkAuth();

    return () => {
      mounted = false;
    };
  }, [isAuthenticated, isLoading, verifyAuth]);

  if (isLoading) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;